import React from 'react';
import { Button } from "react-bootstrap";
import { isMobile } from "react-device-detect";

type FooterLinkProps = {
    label: string;
    url: string;
    onClick: () => void;
};
const FooterLink: React.FC<FooterLinkProps> = ({
    label, url, onClick,
}) => (url
    ? (
        <Button
            id={label}
            variant="link"
            className={`text-start links text-wrap text-decoration-none p-1 ${isMobile ? ' fw-bold' : ''}`}
            onClick={onClick}
        >
            {label}
        </Button>
    )
    : (
        <button
            id="ot-sdk-btn"
            className={`ot-sdk-show-settings ${isMobile ? 'fw-bold' : ''} one-consent`}
            type="button"
            onClick={onClick}
        >
            {label}
        </button>
    ));

export default FooterLink;
